
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gSHwNFTrsY6kC2_45oFAhQOTgPdEzFDg0cXrXb0Dbu1KVgMeta } from "/codebuild/output/src3873879701/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexX6QY8RvEBqJbDGy4_L_45ySUbvfArzheRRrBYAk3FcmNgMeta } from "/codebuild/output/src3873879701/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchmh_45aSJg4v6PYMj_45CUEgKkzZmQtLoX1pWwoMJrtMswPgMeta } from "/codebuild/output/src3873879701/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as index5mgWjwIjkPEByczTo7GYMFbBvlKrANEoc6gtUulSCZYMeta } from "/codebuild/output/src3873879701/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93krjpySvU_45iQNW14nCActVnxcMc_45IACSpdJ9h_45CuNbGUMeta } from "/codebuild/output/src3873879701/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexS_QHgLx81mhHugphvrTx4G_7oIhUH7T1HCtCeeIyfR0Meta } from "/codebuild/output/src3873879701/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_937L0Vo3lHnPxhP8toMaKJIP_45e6OmFL69kHkOiPm_j2OMMeta } from "/codebuild/output/src3873879701/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexvyROF1L1VOI5zzVm7w1GNOtBF9hLjCEWO30rA5lSmg4Meta } from "/codebuild/output/src3873879701/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93nSgDgW4e49qZQ2mQ6PC9OrZY1_45h2seUn8qElDV0PbfcMeta } from "/codebuild/output/src3873879701/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexglak1d__45piuFf2_vJ7xS0Z9YQI2wv5gO80J6v6DqwNcMeta } from "/codebuild/output/src3873879701/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexTsjiy1N2Iw5fO8vhTeiZt0CFBOUNiI5k5vHWFo3JHyoMeta } from "/codebuild/output/src3873879701/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src3873879701/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src3873879701/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src3873879701/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src3873879701/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src3873879701/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexS_QHgLx81mhHugphvrTx4G_7oIhUH7T1HCtCeeIyfR0Meta || {},
    component: () => import("/codebuild/output/src3873879701/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src3873879701/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexvyROF1L1VOI5zzVm7w1GNOtBF9hLjCEWO30rA5lSmg4Meta || {},
    component: () => import("/codebuild/output/src3873879701/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src3873879701/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexglak1d__45piuFf2_vJ7xS0Z9YQI2wv5gO80J6v6DqwNcMeta || {},
    component: () => import("/codebuild/output/src3873879701/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexTsjiy1N2Iw5fO8vhTeiZt0CFBOUNiI5k5vHWFo3JHyoMeta || {},
    component: () => import("/codebuild/output/src3873879701/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]